import RefundSettingTable from "../../components/Settings/RefundSettingsTable";

const SettingPage = () => {
  return (
    <>
      <RefundSettingTable />
    </>
  );
};

export default SettingPage;
